import {
  AlertCircle,
  Archive,
  ArrowDownLeft,
  ArrowUpRight,
  Award,
  BarChart3,
  Bell,
  Book,
  BookOpen,
  Boxes,
  Briefcase,
  Building,
  Calendar,
  CalendarCheck,
  Check,
  CheckCircle,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ClipboardCheck,
  Clock,
  CreditCard,
  DollarSign,
  Download,
  Edit,
  ExternalLink,
  FileCheck,
  FileCode,
  FileQuestion,
  FileText,
  Filter,
  Folder,
  BookMarked,
  Calculator,
  GraduationCap,
  Grid,
  HelpCircle,
  History,
  Inbox,
  Info,
  Key,
  Layers,
  LayoutGrid,
  LifeBuoy,
  type LucideIcon,
  Menu,
  MessageSquare,
  Moon,
  MoreHorizontal,
  MoreVertical,
  Package,
  Palette,
  Plus,
  Receipt,
  RefreshCw,
  School,
  Search,
  Settings,
  Shield,
  Shuffle,
  Sliders,
  Sparkles,
  Sun,
  Trash2,
  TrendingUp,
  Upload,
  User,
  UserCheck,
  UserPlus,
  Users,
  Video,
  Webhook,
  Wrench,
  X,
  Zap,
  Trophy,
  Target,
  Play,
  ShoppingCart,
  ShoppingBag,
  Gift,
  Share2,
  Brain,
  Compass,
  Star,
  Eye,
  Send,
  PieChart,
  Activity,
  Tag,
  ShieldAlert,
  Lock,
  ScanFace,
  ShieldCheck,
} from 'lucide-react';

export const iconRegistry: Record<string, LucideIcon> = {
  // Suites & Nav
  archive: Archive,
  wrench: Wrench,
  book: Book,
  'book-open': BookOpen,
  boxes: Boxes,
  briefcase: Briefcase,
  building: Building,
  'credit-card': CreditCard,
  'dollar-sign': DollarSign,
  'file-text': FileText,
  grid: Grid,
  'help-circle': HelpCircle,
  inbox: Inbox,
  layers: Layers,
  'life-buoy': LifeBuoy,
  package: Package,
  receipt: Receipt,
  settings: Settings,
  shuffle: Shuffle,
  sliders: Sliders,
  'trending-up': TrendingUp,
  users: Users,
  user: User,
  'user-check': UserCheck,
  'user-plus': UserPlus,

  // Education & Coaching Suites
  'graduation-cap': GraduationCap,
  school: School,
  video: Video,
  calendar: Calendar,
  'calendar-check': CalendarCheck,
  'message-square': MessageSquare,
  clock: Clock,
  'bar-chart': BarChart3,
  award: Award,
  trophy: Trophy,
  target: Target,
  play: Play,
  'shopping-cart': ShoppingCart,
  'shopping-bag': ShoppingBag,
  gift: Gift,
  'share-2': Share2,
  brain: Brain,
  compass: Compass,
  star: Star,
  eye: Eye,
  send: Send,
  'pie-chart': PieChart,
  activity: Activity,
  tag: Tag,
  'file-question': FileQuestion,
  'file-check': FileCheck,
  'file-code': FileCode,
  'book-marked': BookMarked,
  folder: Folder,
  calculator: Calculator,
  'clipboard-check': ClipboardCheck,
  'check-circle': CheckCircle,
  'check-circle-2': CheckCircle2,
  'alert-circle': AlertCircle,

  // Settings & Vigilance features
  key: Key,
  palette: Palette,
  shield: Shield,
  'shield-alert': ShieldAlert,
  'shield-check': ShieldCheck,
  lock: Lock,
  'scan-face': ScanFace,
  webhook: Webhook,
  zap: Zap,

  // Shell & Navigation UI
  bell: Bell,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  history: History,
  'layout-grid': LayoutGrid,
  menu: Menu,
  moon: Moon,
  search: Search,
  sparkles: Sparkles,
  sun: Sun,
  x: X,

  // Actions & States
  'arrow-down-left': ArrowDownLeft,
  'arrow-up-right': ArrowUpRight,
  check: Check,
  download: Download,
  edit: Edit,
  'external-link': ExternalLink,
  filter: Filter,
  info: Info,
  'more-horizontal': MoreHorizontal,
  'more-vertical': MoreVertical,
  plus: Plus,
  'refresh-cw': RefreshCw,
  'trash-2': Trash2,
  upload: Upload,
};

export type IconName = keyof typeof iconRegistry;
